function selectedId(value) {
  if (!value) return '';
  if (typeof value === 'string') return value;
  return value.id || '';
}

function fill(sentences, values) {
  return (sentences || [])
    .filter(Boolean)
    .map((sentence) => sentence
      .replaceAll('{{label}}', values.label || '')
      .replaceAll('{{email}}', values.email || '')
      .replaceAll('{{nhsNumber}}', values.nhsNumber || ''))
    .join(' ');
}

export function adviseQualityAlert(template, fields, nhsNumber) {
  if (!template?.sentences?.length) return '';
  if (template.type === 'NCL') {
    if (!template.email) return 'Choose a destination on the form before sending.';
    return fill(template.sentences, { email: template.email, nhsNumber });
  }
  const provider = (template.providers || []).find((option) => option.id === selectedId(fields?.provider));
  if (!provider?.email) return 'Choose a destination on the form before sending.';
  return fill(template.sentences, { label: provider.label, email: provider.email, nhsNumber });
}

export function deliveryTarget(template, fields) {
  if (!template) return { email: '', label: '' };
  if (template.type === 'NCL') {
    return { email: template.email || '', label: template.email || '' };
  }
  const provider = (template.providers || []).find((option) => option.id === selectedId(fields?.provider));
  return { email: provider?.email || '', label: provider?.label || '' };
}
